import { createContext, useEffect, useState, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import API from "./API/newIndex";
import AddBlogCategory from "./Component/Blog/AddBCategory";
import AddBlog from "./Component/Blog/AddBlog";
import AddBlogComments from "./Component/Blog/AddBlogComments";
import AddBlogGroup from "./Component/Blog/AddBlogGroup";
import BlogCategories from "./Component/Blog/BlogCategory";
import BlogComments from "./Component/Blog/BlogComments";
import EditBlogGroup from "./Component/Blog/EditBlogGroup";
import GetBlogGroup from "./Component/Blog/GetBlogGroup";
import MyBlogs from "./Component/Blog/MyBlogs";
import PerticularBlogComment from "./Component/Blog/PerticularBlogComment";
import UpdateBlog from "./Component/Blog/UpdateBlog";
import UpdateBlogCategory from "./Component/Blog/UpdateBlogCategory";
import Loader from "./Component/Loader/Loader";
import ErrorPage from "./Component/Main/ErrorPage";
import { GetClient } from "./controllers/GetClient";
import { LastRouteProvider } from "./controllers/LastRouteContext";
import { RichTextProvider } from "./Component/custom-texteditor/RichTextContext";
import { TableColumnsContext } from "./controllers/TableColumnsContext";
import { UserProvider, UserContext } from "./controllers/UserContext";
import { AuthorProvider, AuthorContext } from "./controllers/AuthorContext";

export { TableColumnsContext, UserContext, AuthorContext };
export const ChangePathContext = createContext();
export const PlanPermission = createContext();
export const DataLoad = createContext();
export const SelectSection = createContext();
export const Extention = createContext();
export const StoreDeletePending = createContext();

const App = () => {
  let token = localStorage.getItem("token");
  const [installedExtensions, setInstalledExtensions] = useState([]);
  const [planActive, setPlanActive] = useState(false);
  const [spinner, setSpinner] = useState(token ? true : false);
  const [Permissions, setPermissions] = useState();
  const [accessDenied, setAccessDenied] = useState(false);
  const [tokenReady, setTokenReady] = useState(!!localStorage.getItem("token"));
  const [tableColumnsData, setTableColumnsData] = useState(null);
  const tableColumnsDataRef = useRef(null);
  const isFetchingTableColumns = useRef(false);

  let business_name = localStorage.getItem("business_name");
  const navigate = useNavigate();

  const installExtentionName =
    installedExtensions?.length > 0 ? installedExtensions?.map((x) => x?.super_extension_id) : [];
  const [saveChanges, setSaveChanges] = useState({
    isUnsaveChanges: false,
    showChangesPopup: false,
    backLink: "",
    title: "",
  });
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: true,
    forModule: null,
  });
  const [dataLoading, setDataLoading] = useState(false);

  const getTableColumns = async (force = false) => {
    if (!force && (tableColumnsDataRef.current || tableColumnsData)) {
      return tableColumnsDataRef.current || tableColumnsData;
    }
    if (isFetchingTableColumns.current) return;

    isFetchingTableColumns.current = true;
    try {
      const res = await API({ url: "/admin/product/getTableColumns", method: "get" });
      if (res?.data) {
        tableColumnsDataRef.current = res.data;
        setTableColumnsData(res.data);
        return res.data;
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      isFetchingTableColumns.current = false;
    }
  };

  const GetInstalledExtensions = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/extension/GetInstalledExtensions`,
        method: "get",
      });
      if (ApiCall.data) {
        const result = ApiCall?.data;
        setInstalledExtensions(result?.data);
        return result?.data;
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const GetUserPermissions = async () => {
    try {
      let ApiCall = await API({ url: "/admin/role/getLoginUserRole", method: "get" });
      const result = ApiCall?.data;
      setPermissions(result);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const GetAnnouncemnet = async () => {
    try {
      await API({
        url: `/admin/announcement/UserGetAnnouncements?type=1&limit=3&page=1`,
        method: "get",
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const CheckPlanStatus = async () => {
    if (business_name?.length > 0) {
      setSpinner(true);
      try {
        await API({ url: `/admin/plan/planStatusCheck`, method: "get" });
        setPlanActive(true);
        await GetInstalledExtensions();
        await GetUserPermissions();
        await GetAnnouncemnet();
      } catch (error) {
        if (error?.response?.status === 498) {
          setPlanActive(false);
        } else {
          console.log(error, "error");
        }
      } finally {
        setSpinner(false);
      }
    } else {
      setPlanActive(false);
    }
  };

  useEffect(() => {
    // Initial dark mode application
    const savedDarkMode = localStorage.getItem("dark-mode");
    if (savedDarkMode === "true" || savedDarkMode === true) {
      document.documentElement.classList.add("dark-mode");
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark-mode");
      document.documentElement.classList.remove("dark");
    }

    if (window.self === window.top) {
      setAccessDenied(true);
      return;
    }

    if (!document.referrer || !document.referrer.startsWith(process.env.REACT_APP_ADMIN_URL)) {
      setAccessDenied(true);
      return;
    }

    window.addEventListener("message", (event) => {
      if (event.origin === process.env.REACT_APP_ADMIN_URL) {
        const data = event.data;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            localStorage.setItem(key, data[key]);
          }
        }

        if (data.token) {
          setTokenReady(true);
        }

        if (data?.type === "NAVIGATE_IFRAME_INTERNAL" && typeof data.path === "string") {
          navigate(data.path);
        }

        if (data?.type === "DARK_MODE_CHANGE" || data?.type === "INIT_IFRAME") {
          const isDarkMode =
            data?.type === "DARK_MODE_CHANGE"
              ? data["dark-mode"]
              : data["dark-mode"] === "true" || data["dark-mode"] === true;
          localStorage.setItem("dark-mode", isDarkMode);
          if (isDarkMode) {
            document.documentElement.classList.add("dark-mode");
            document.documentElement.classList.add("dark");
          } else {
            document.documentElement.classList.remove("dark-mode");
            document.documentElement.classList.remove("dark");
          }
        }
      } else {
        console.warn("Message origin not trusted:", event.origin);
      }
    });
  }, []);

  useEffect(() => {
    if (!tokenReady) return;

    // These functions require token to be available
    GetInstalledExtensions();
    CheckPlanStatus();
    GetClient();
    getTableColumns();
  }, [tokenReady]);

  return (
    <UserProvider tokenReady={tokenReady}>
      <AuthorProvider>
        <TableColumnsContext.Provider value={{ tableColumnsData, setTableColumnsData, getTableColumns }}>
          <LastRouteProvider>
            <ChangePathContext.Provider value={{ saveChanges, setSaveChanges }}>
              <PlanPermission.Provider value={{ planPermission, setPlanPermission }}>
                <DataLoad.Provider value={{ dataLoading, setDataLoading }}>
                  <RichTextProvider>
                    {/* blog section */}
                    <Routes>
                      {installExtentionName?.length > 0 && installExtentionName?.includes("6683eb75529fd09fc74be63c") && (
                        <>
                          <Route path="/blog/post" element={<MyBlogs />} />
                          <Route path="/blog/post/add" element={planActive && <AddBlog />} />
                          <Route path="/blog/post/:blog_slug" element={planActive && <UpdateBlog />} />
                          <Route path="/blog/categories" element={<BlogCategories />} />
                          <Route
                            path="/blog/categories/add"
                            element={planActive && <AddBlogCategory />}
                          />
                          <Route
                            path="/blog/categories/:blogcatid"
                            element={planActive && <UpdateBlogCategory />}
                          />
                          <Route path="/blog/comments" element={<BlogComments />} />
                          <Route path="/blog/comments/add-blog/comments" element={<AddBlogComments />} />
                          <Route path="/blog/comments/:commentId" element={<PerticularBlogComment />} />
                          <Route path="/module-setting/blog-group" element={<GetBlogGroup />} />
                          <Route path="/module-setting/blog-group/:groupId" element={<EditBlogGroup />} />
                          <Route
                            path="/module-setting/blog-group/add-blog-group"
                            element={<AddBlogGroup />}
                          />
                        </>
                      )}
                      <Route path="/*" element={planActive || (accessDenied && <ErrorPage />)} />
                    </Routes>
                  </RichTextProvider>
                </DataLoad.Provider>
              </PlanPermission.Provider>
            </ChangePathContext.Provider>
          </LastRouteProvider>
        </TableColumnsContext.Provider>
      </AuthorProvider>
    </UserProvider>
  );
};

export default App;
